import type { QueryClient } from "@tanstack/react-query";

export type CaseCacheData = {
    data: {
        id: number;
        idUUID: string;
    };
};

export const invalidateCaseQueries = async (
    queryClient: QueryClient,
    caseUUID: string,
): Promise<void> => {
    await queryClient.invalidateQueries({
        queryKey: ["case", caseUUID],
    });

    await queryClient.invalidateQueries({
        queryKey: ["case-uuid", { caseUUID }],
    });

    const cacheData = queryClient.getQueryData<CaseCacheData>(["case-uuid", { caseUUID }]);

    if (cacheData?.data?.id) {
        await queryClient.invalidateQueries({
            queryKey: ["case", String(cacheData.data.id)],
        });
    }
};
